<template>
  <ECModal
    @close="$emit('close')"
    :title="modalTitle"
    cache
  >
    <div v-if="successSendedForm" class="successSended">
      <img src="@/assets/images/success-send-support.svg" alt="">
      <span>Ваша заявка успешно принята!</span>
      <p v-if="email.length > 3">На указанный вами электронный адрес отправлена копия заявки. Проверьте свою электронную  почту.</p>
      <p v-else>Вам перезвонят на указанный номер.</p>
    </div>

    <form
      id="create-contract-tko"
      v-if="!successSendedForm"
      class="content"
      @submit.prevent=""
    >

      <div class="step" v-if="!isStepSecond">
        <div class="form-item">
          <label class="required">Контактное лицо</label>
          <ECInput
            v-model="name"
            placeholder="Введите свое имя"
            type="text"
            required
          />
        </div>

        <div class="form-item form-item--checkbox">
          <ECCheckbox
            label="Я - собственник коммерческой недвижимости (Физ. лицо)"
            :checked="individual"
            @clicked="individual = !individual"
          />
        </div>

        <div class="form-item">
          <label class="required">ИНН</label>
          <ECInput
            v-model="inn"
            masked="inn"
            placeholder="Введите 10-12 цифр"
            :error="INNerror"
            :disabled="individual"
          />

          <transition name="default">
            <div class="dadata" v-if="daDataArr.length && isShowDaDataMenu">
              <div class="dadata-item"
                v-for="item in daDataArr"
                :key="item.inn"
                @click="setDaData(item)"
              >
                <span>{{item.label}}</span>
                <span>ИНН {{item.inn}} <template v-if="item.kpp">/ КПП {{item.kpp}}</template></span>
              </div>
            </div>
          </transition>
        </div>

        <div class="form-item">
          <label class="required">Телефон</label>
          <ECInput
            placeholder="+7"
            masked="tel"
            v-model="phone"
          />
        </div>

        <div class="form-item">
          <label>Электронная почта</label>
          <ECInput
            placeholder="client@company.ru"
            v-model="email"
            maxLength="127"
          />
        </div>

        <ECButton
          label="Далее"
          view="primary"
          @click="isStepSecond = true"
          :disabled="!isValidfirstStep"
        />
      </div>

      <div v-else class="step">
        <div class="points-list">
          <div
            class="point"
            v-for="(point, index) in points"
            :key="index"
          >
            <div class="content">
              <img class="point-svg" src="@/assets/images/point-mini.svg" alt="">
              <div class="geo">
                <div class="address">{{point.dadata.value}}</div>
                <div class="sign">{{point.sign}}</div>
              </div>
            </div>
            <div class="remove" @click="points.splice(index, 1)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-53c28155=""><path fill-rule="evenodd" clip-rule="evenodd" d="M4.09503 3.74836C4.42863 2.45527 5.6028 1.5 7.00009 1.5H17.0001C18.3974 1.5 19.5716 2.45527 19.9052 3.74836L22.3174 4.55559C22.7823 4.71116 23.0659 5.18081 22.9871 5.66467C22.9083 6.14852 22.4903 6.50391 22.0001 6.50391L20.7069 6.50391C20.7096 7.55187 20.7122 8.57446 20.7139 9.15245C20.7245 12.7316 20.7002 15.1027 20.4066 18.3235C20.3026 19.4647 19.8197 20.414 19.0204 21.0674C18.2342 21.7102 17.2247 22 16.1667 22H7.83339C6.7754 22 5.76593 21.7102 4.9797 21.0674C4.18042 20.414 3.69754 19.4647 3.59352 18.3235C3.29993 15.1027 3.27558 12.7316 3.28619 9.15245C3.2879 8.57445 3.29055 7.55187 3.29318 6.50391H2.00009C1.50986 6.50391 1.09191 6.14852 1.0131 5.66467C0.934287 5.18081 1.21786 4.71116 1.68275 4.55559L4.09503 3.74836ZM5.00009 4.5L5.0014 4.50391L18.9988 4.50391L19.0001 4.5H18.0001C18.0001 3.94772 17.5524 3.5 17.0001 3.5H7.00009C6.44781 3.5 6.00009 3.94772 6.00009 4.5H5.00009ZM18.7069 6.50391L5.29319 6.50391C5.29055 7.55371 5.2879 8.57902 5.28618 9.15838C5.27561 12.7223 5.30045 15.0175 5.58526 18.1419C5.64576 18.8057 5.90427 19.24 6.24555 19.519C6.59988 19.8087 7.13014 20 7.83339 20H16.1667C16.87 20 17.4002 19.8087 17.7546 19.519C18.0958 19.24 18.3544 18.8057 18.4149 18.1419C18.6996 15.0175 18.7245 12.7223 18.7139 9.15838C18.7122 8.57902 18.7096 7.55371 18.7069 6.50391Z" fill="#C6C6C6" data-v-53c28155=""></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.42759 8.88353C8.97842 8.84351 9.4574 9.25761 9.49742 9.80844L9.99742 16.6908C10.0374 17.2416 9.62334 17.7206 9.0725 17.7606C8.52167 17.8006 8.04269 17.3865 8.00267 16.8357L7.50267 9.95336C7.46265 9.40253 7.87675 8.92355 8.42759 8.88353ZM15.5725 8.88353C16.1233 8.92355 16.5374 9.40253 16.4974 9.95336L15.9974 16.8357C15.9574 17.3865 15.4784 17.8006 14.9276 17.7606C14.3768 17.7206 13.9627 17.2416 14.0027 16.6908L14.5027 9.80844C14.5427 9.25761 15.0217 8.84351 15.5725 8.88353Z" fill="#C6C6C6" data-v-53c28155=""></path></svg>
            </div>
          </div>
        </div>

        <div class="form-item">
          <label class="required">Адрес оказания услуги</label>
          <ECInput
            v-model="address"
            placeholder=""
            required
          />
          <transition name="default">
            <div class="dadata dadata--address" v-if="daDataArrAddress.length && isShowDaDataMenuAddress">
              <div class="dadata-item"
                v-for="item in daDataArrAddress"
                :key="item.value"
                @click="setDaDataAddress(item)"
              >
                <span>{{item.value}}</span>
              </div>
            </div>
          </transition>
        </div>

        <div class="form-item">
          <div class="infos">
            <img class="infos__icon" src="@/assets/images/info-circle.svg" alt="">
            <div class="infos__pop">
              <img src="@/assets/images/trg.svg" alt="">
              Название часто отличается от наименования юр.лица, поэтому нам требуется уточняющая информация. Это упростит процедуру вывоза.
            </div>
          </div>
          <label class="required">Название(вывеска)</label>
          <ECInput
            placeholder="Магазин “Ромашка”"
            v-model="sign"
          />
        </div>

        <div class="form-item--btn">
          <ECButton
            :label="isStepSecond ? 'Отправить заявку' : 'Далее'"
            view="primary"
            @click="sendForm"
            :disabled="!isValidSecondStep"
          />
        </div>

        <ECButton
          :label="`Добавить ${points.length > 0  && successSendedForm ? 'еще' : ''} адрес`"
          view="grey"
          @click="addPoint"
          :disabled="!isValidAddPointBtn"
        />
      </div>
    </form>

  </ECModal>
</template>

<script setup>
import {ref, computed, watchEffect, watch, getCurrentInstance, onMounted} from 'vue'
import useApi from '@/services/useApi'

const app = getCurrentInstance()

const name = ref('')

const inn = ref('')
const kpp = ref('')
const dadataLabel = ref('')

const INNerror = ref('')
const flagDadata = ref(true)
const daDataArr = ref([])
const isShowDaDataMenu = ref(false)
const isValideInn = ref(false)

const phone = ref('')
const email = ref('')

const individual = ref(false)

const isStepSecond = ref(false)

const address = ref('')
const addressPayload = ref({})
const daDataArrAddress = ref([])
const isShowDaDataMenuAddress = ref(false)

const sign = ref('')

const points = ref([])

const successSendedForm = ref(false)

const setDaData = (x) => {
  kpp.value = x.kpp
  dadataLabel.value = x.label
  inn.value = x.inn
  isValideInn.value = true
  isShowDaDataMenu.value = false
}

const setDaDataAddress = (x) => {
  addressPayload.value = x
  address.value = x.value
  isShowDaDataMenuAddress.value = false
  flagDadata.value = false
}

watchEffect(async() => {
  isValideInn.value = false
  if(inn.value.length === 10 || inn.value.length === 12){

    const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party"
    const token = "f94a30447c5eaf823177a205adbcd6df33603ba9"
    const options = {
      method: "POST",
      mode: "cors",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Token " + token
      },
      body: JSON.stringify({
        query: inn.value,
        count: 300
      })
    }
    const data = await fetch(url, options)
    const dd = await data.json()

    if(dd.suggestions.length){
      daDataArr.value = dd.suggestions.map(item => {
        return {
          label: item.value,
          inn: item.data.inn,
          kpp: item.data.kpp || '',
        }
      })
      isShowDaDataMenu.value = true

      INNerror.value = ''
    } else {
      INNerror.value = 'Такого ИНН не найдено'
    }
  } else {
    daDataArr.value = []
  }
})

watchEffect(async() => {
  if(address.value.length >= 3 && flagDadata.value){
    const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address"
    const token = "f94a30447c5eaf823177a205adbcd6df33603ba9"
    const options = {
      method: "POST",
      mode: "cors",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Token " + token
      },
      body: JSON.stringify({
        query: address.value,
        restrict_value: true,
        locations: [{kladr_id: "0200000000000"}],
        locations_boost: [{kladr_id: "7800000000000"}],
        count: 10
      })
    }
    const data = await fetch(url, options)
    const dd = await data.json()
    daDataArrAddress.value = dd.suggestions

    isShowDaDataMenuAddress.value = true
  } else {
    daDataArrAddress.value = []
  }
  flagDadata.value = true
})

const isValidfirstStep = computed(() =>
  (((inn.value.length === 10 || inn.value.length === 12) && isValideInn.value) || individual.value) &&
  name.value.length >= 2 &&
  phone.value.length === 16
)

const isValidSecondStep = computed(() =>
  isValidfirstStep.value &&
  (points.value.length || (points.value.length === 0 && isValidAddPointBtn.value !== 0))
)

const addPoint = () => {
  points.value.push({
    dadata: addressPayload.value,
    sign: sign.value
  })

  addressPayload.value = {}
  sign.value = ''
  address.value = ''
}

const isValidAddPointBtn = computed(()=> sign.value.length && address.value.length)

const sendForm = async () => {
  successSendedForm.value = true

  if(points.value.length === 0 && isValidAddPointBtn.value !== 0){
    points.value.push({
      dadata: addressPayload.value,
      sign: sign.value
    })
  }

  const req = await useApi('post', 'requests/new_point', {
    name: name.value,
    phone: phone.value,
    email: email.value,
    points: points.value,

    inn: inn.value,
    kpp: kpp.value,
    label: dadataLabel.value,

    individual: individual.value
  })
}

const modalTitle = computed(()=> {
  if(successSendedForm.value) return ''

  return isStepSecond.value ? 'Добавьте адрес обслуживания' : 'Заявка на заключение договора'
})


watch(
  () => individual.value,
  () => {
    if(individual.value){
      kpp.value = ''
      dadataLabel.value = ''
      inn.value = ''
      INNerror.value = ''
    }
  }
)
</script>

<style scoped lang="scss">
.form-item{
  position: relative;
  &--btn{
    margin-bottom: 10px;
  }
  .infos{
    position: absolute;
    right: 0;
    top: 0;
    z-index: 3;

    &__pop{
      position: absolute;
      z-index: 2;
      right: 46px;
      top: -54px;
      padding: 16px;
      width: 200px;
      font-weight: 500;
      font-size: 12px;
      line-height: 130%;
      background: #FFFFFF;
      border-radius: 26px;
      filter: drop-shadow(0px 0px 30px rgba(0, 0, 0, 0.1));
      transition: ease .3s;
      opacity: 0;
      visibility: hidden;
      img{
        position: absolute;
        right: -14px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    &__icon{
      cursor: pointer;

      &:hover{
        +.infos__pop{
          right: 36px;
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }
}

.point{
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: $ec-grey;
  padding: 12px 16px;
  border-radius: 16px;
  margin-bottom: 20px;
  .content{
    display: flex;
    align-items: center;
    .point-svg{
      margin-right: 7px;
    }
    .geo{
      .sign{
        opacity: .5;
      }
    }
  }
  .remove{
    cursor: pointer;
    *{
      transition: ease .3s;
    }
    &:hover{
      svg{
        path{
          fill: #FE6F6F;
        }
      }
    }
  }
}

.successSended{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  span{
    margin-top: 20px;
    font-size: 22px;
    line-height: 22px;
    text-align: center;
  }
  p{
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.01em;
    color: rgba(66, 66, 66, 0.5);
    margin-top: 20px;
    padding-bottom: 20px;
  }
}

.form-item--checkbox:deep(span) {
  svg{
      top: 8px !important;
    }
  &:before{
    top: 8px !important;
  }
}
</style>
